import { getBridge } from "@/src/lib/bridge/bridge";
import type { ChecklistStepKey } from "../types";

/**
 * 通知项只能在 App 内完成：授权与打标走原生 `enablePushWithPermission`，
 * 纯 web 没有对应通道（桥请求会一直等到 30s 超时），所以 web 上不展示 Turn on 按钮，
 * 只提示去 App 里打开。
 */
export function isWebNotificationBlocked(stepKey: ChecklistStepKey): boolean {
  return stepKey === "notification" && !getBridge().isInApp();
}
